/* Shared ordinary-crop geometry rules. Keep the Lambda copy byte-identical. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.GIOCropGeometryCore = api;
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  function invalid() {
    var error = new Error('This product size could not be prepared. Please choose another option or contact us.');
    error.code = 'GIO_PRODUCT_GEOMETRY';
    return error;
  }
  // Preserve numeric SKU/tag arithmetic without executing JavaScript. Missing
  // configuration is a free crop; an explicit malformed size is never free.
  function parseRatio(value) {
    if (value == null || typeof value === 'string' && !value.trim()) return null;
    var text = String(value).trim(), position = 0, depth = 0;
    if (text.length > 128 || !/^[\d.\s()+*/-]+$/.test(text)) throw invalid();
    function space() { while (/\s/.test(text.charAt(position)) && position < text.length) position++; }
    function primary() {
      space();
      var sign = 1;
      while (text[position] === '+' || text[position] === '-') { if (text[position++] === '-') sign = -sign; space(); }
      var result;
      if (text[position] === '(') {
        if (++depth > 16) throw invalid();
        position++; result = expression(); space();
        if (text[position++] !== ')') throw invalid();
        depth--;
      } else {
        var match = /^(?:\d+(?:\.\d*)?|\.\d+)/.exec(text.slice(position));
        if (!match) throw invalid();
        position += match[0].length; result = Number(match[0]);
      }
      result *= sign;
      if (!Number.isFinite(result)) throw invalid();
      return result;
    }
    function term() {
      var result = primary(); space();
      while (text[position] === '*' || text[position] === '/') {
        var operator = text[position++], next = primary();
        result = operator === '*' ? result * next : result / next;
        if (!Number.isFinite(result)) throw invalid();
        space();
      }
      return result;
    }
    function expression() {
      var result = term(); space();
      while (text[position] === '+' || text[position] === '-') {
        var operator = text[position++], next = term();
        result = operator === '+' ? result + next : result - next;
        if (!Number.isFinite(result)) throw invalid();
        space();
      }
      return result;
    }
    var ratio = expression(); space();
    if (position !== text.length || !Number.isFinite(ratio) || ratio <= 0) throw invalid();
    return ratio;
  }
  function skuValue(sku, keyword) {
    var parts = String(sku == null ? '' : sku).split('_').slice(1);
    for (var i = 0; i < parts.length; i++) if (parts[i].charAt(0) === keyword) return parts[i].slice(1);
    return null;
  }
  function resolve(sku, tags) {
    var expression = skuValue(sku, 's'), source = 'sku';
    // An empty _s historically falls back to the product size tag.
    if (!expression) {
      source = 'tag'; expression = null;
      (Array.isArray(tags) ? tags : []).forEach(function (tag) {
        if (typeof tag === 'string' && tag.indexOf('_pic') === -1 && tag.indexOf('_size') !== -1) expression = tag.split('_size')[1];
      });
    }
    var ratio = parseRatio(expression);
    return { ratio: ratio, source: ratio === null ? 'free' : source, expression: expression == null ? '' : String(expression) };
  }
  function canonicalOutput(ratio) {
    if (!Number.isFinite(ratio) || ratio <= 0) throw invalid();
    return { width: Math.max(1, Math.round(ratio >= 1 ? 6000 : 6000 * ratio)),
      height: Math.max(1, Math.round(ratio >= 1 ? 6000 / ratio : 6000)) };
  }
  return { parseRatio: parseRatio, skuValue: skuValue, resolve: resolve, canonicalOutput: canonicalOutput };
}));
